import React, { useState, useEffect } from "react";
import { Layout, Button } from "antd";

import axios from "../../../helpers/axios";
import { errorAlert } from "../../../helpers/notification";

import CareerForm from "./CareerForm";
import CareerCard from "./CareerCard";

import "../../../App.css";

const { Content, Header } = Layout;

const Career = () => {
  const [visible, setVisible] = useState(false);
  const [careers, setCareers] = useState([]);

  const getCareers = () => {
    axios
      .get("/career")
      .then(({ data: { data } }) => {
        setCareers(data);
      })
      .catch(() => {
        errorAlert();
      });
  };

  useEffect(() => {
    getCareers();
  }, []);

  return (
    <Content
      style={{ margin: "80px 16px 0", overflow: "initial", background: "#FFF" }}
    >
      <Header style={{ padding: "0 16px", textAlign: "end" }}>
        <Button onClick={() => setVisible(true)}>Add Career</Button>
      </Header>
      <CareerForm
        visible={visible}
        setVisible={setVisible}
        getCareers={getCareers}
      />
      <div
        style={{
          padding: "16px 0",
          display: "grid",
          gridTemplateColumns: "31.4% 31.4% 31.4%",
          justifyContent: "center",
          gridGap: "16px",
        }}
      >
        {careers.map((career) => (
          <CareerCard key={career.id} career={career} getCareers={getCareers} />
        ))}
      </div>
    </Content>
  );
};

export default Career;
